export class AtlasClusters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusters",
            "baseName": "clusters",
            "type": "Array<AtlasCluster>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AtlasClusters.attributeTypeMap;
    }
    constructor() {
    }
}
